import PropTypes from 'prop-types'
import React, { createContext, useRef, useState } from 'react'
import { LayoutGroup } from './LayoutGroup'

export const LayoutContext = createContext({
  leftPanelChildren: <></>,
  rightPanelChildren: <></>,
  isRightPanelOpen: false,
  isLeftPanelOpen: false,
  keepLeftPanelOpen: false,
  showOverlay: false,
  layoutRef: null,
})

const Layout = ({ children }) => {
  const layoutRef = useRef()
  const [showOverlay, setShowOverlay] = useState(false)

  const [isRightPanelOpen, onToggleRightPanel] = useState(false)

  const [isLeftPanelOpen, onToggleLeftPanel] = useState(() => {
    const leftPanel = !!document.querySelector('.left-panel')
    return leftPanel || window.innerWidth >= 1280
  })
  const [highlightElement, setHighlightElement] = useState(null)
  return (
    <LayoutContext.Provider
      value={{
        onToggleLeftPanel,
        onToggleRightPanel,
        isRightPanelOpen,
        isLeftPanelOpen,
        showOverlay,
        setShowOverlay,
        setHighlightElement,
        highlightElement,
        layoutRef,
      }}
    >
      <LayoutGroup>{children}</LayoutGroup>
    </LayoutContext.Provider>
  )
}

Layout.displayName = 'Layout'

Layout.propTypes = {
  children: PropTypes.node,
}

export default Layout
